export default "__VITE_ASSET__hL09x_kn__"